import { combineReducers } from "redux";
import { _FAILURE, _SUCCESS, FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST } from "./constants";
import { Doctor } from "../types";
import { Action } from "./types";
import { Action as DoctorAction } from "../doctor/types";

function items(state: Doctor[] = [], action: Action | DoctorAction): Doctor[] {
  switch (action.type) {
    case FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST + _SUCCESS:
      return action.payload.data;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST:
      return true;
    case FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST + _SUCCESS:
    case FETCH_DOCTORS_WITH_EVERY_QUERY_REQUEST + _FAILURE:
      return false;
    default:
      return state;
  }
}

export const doctorsWithEveryQuery = combineReducers({ items, isFetching });
